// extracted by mini-css-extract-plugin
module.exports = {"messageText":"_54dd8a1"};